"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var SelloutTypeWithItemCounts_1 = require("../SelloutTypeWithItemCounts");
/**
 * <p>
 *     DTO object to hold aggregated data of sellout identification overview for certain category.
 * </p>
 *
 * @see SelloutIdentificationOverview
 * @author Adam Drda
 */


var SelloutIdentificationDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutIdentificationDTO, _DomainObject_1$Domai);

  function SelloutIdentificationDTO(categoryId, dataPerCategory) {
    var _this;

    _classCallCheck(this, SelloutIdentificationDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutIdentificationDTO).call(this));
    _this.categoryId = categoryId;
    _this.dataPerCategory = dataPerCategory;
    return _this;
  }

  return SelloutIdentificationDTO;
}(DomainObject_1.DomainObject);

exports.SelloutIdentificationDTO = SelloutIdentificationDTO;

SelloutIdentificationDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutIdentificationDTO.name);
  return {
    categoryId: builder.str('categoryId'),
    dataPerCategory: builder.listOf(builder.obj('dataPerCategory', SelloutTypeWithItemCounts_1.SelloutTypeWithItemCounts.schema, function (mat) {
      return SelloutTypeWithItemCounts_1.SelloutTypeWithItemCounts.fromDataDict(mat);
    }))
  };
}();